import _ from "lodash";
import Images from "../../constants/lotto5Images";
import {isBonus} from "../../constants/general";
import {moneyFormatter} from "../../utils/MoneyUtils";
import Printer from "../print/Printer";
import Paginate from "../table/Paginate";
import SweetAlert from "react-bootstrap-sweetalert";
import TicketDetail from "../lotto6/TicketDetail";
import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";

const MainTableWinReport = ({tickets, size, totals, summary, onChangPage}) => {

    const {t} = useTranslation();
    const [dataDetail, setDataDetail] = useState(null);
    const [page, setPage] = useState(1);

    const getResultType = (code, last = " / ") => {
        return code !== "" ? t("labels:drawing.drawPrefix." + code) + last : ""
    }


    return <div className="">
        <div className="table-container pt-0">
            <table className="table-custom">
                <thead>
                <tr>
                    <th className="text-center">{t("labels:report.no")}</th>
                    <th className="text-center">{t("labels:report.ticketCode")}</th>
                    <th className="text-center">{t("labels:report.drawCodeTime")}</th>
                    <th className="text-center">{t("labels:report.result")}</th>
                    <th className="text-center">{t("labels:report.qty")}</th>
                    <th className="text-center">{t("labels:report.betAmount")}</th>
                    <th className="text-center">{t("labels:report.win")}</th>
                    <th className="text-center">{t("labels:report.bonus")}</th>
                    <th className="text-center">{t("labels:report.winLose")}</th>
                    <th className="text-center">{t("labels:report.print")}</th>
                </tr>
                </thead>
                <tbody>
                {
                    _.isEmpty(tickets)
                        ? <tr>
                            <td colSpan={10}><img className="data-not-found-img"
                                                  src={Images.dataNotFound} alt="..."/></td>
                        </tr>
                        : tickets.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center f-bold">{item.ticketCode}</td>
                                    <td className="text-center"><span
                                        className="title-ticket-id-btn"
                                        onClick={() => setDataDetail(item)}>{`${item.drawLabel}`}</span>
                                    </td>
                                    <td className="text-center">{item.result + " => "
                                        + t("labels:drawing.drawPrefix." + item.underOverCode) + " / "
                                        + getResultType(item.oddEvenCode)
                                        + getResultType(item.colorCode, "")
                                        + getResultType(item.rangeCode, "")
                                    }
                                        {isBonus(item.bonusCode) && <>
                                            {" / "} {t("labels:ticket.bonus_label")}{" "}
                                            {t("labels:betPrefix." + item.bonusCode)}
                                        </>}
                                    </td>
                                    <td className="text-center">{item.quantity}</td>
                                    <td className="text-right pr-2">
                                        {moneyFormatter(item.betAmount, item.currencyCode)}
                                    </td>
                                    <td className="text-right pr-2">
                                        {moneyFormatter(item.winAmount, item.currencyCode, "text-danger")}
                                    </td>
                                    <td className="text-right pr-2">
                                        {moneyFormatter(item.bonusAmount, item.currencyCode, "text-danger")}
                                    </td>
                                    <td className="text-right pr-2">
                                        {moneyFormatter(item.winLoseAmount, item.currencyCode, "text-primary")}
                                    </td>
                                    <td>{(item.winAmount > 0 || item.bonusAmount > 0) ?
                                        <Printer data={item} lottoType="LOTTO5"/> : null}</td>
                                </tr>
                            );
                        })
                }
                <tr className="win-footer">
                    <td className="text-center" colSpan={5}><span
                        className="pl-2">{t("labels:common.total")}</span></td>
                    <td className="text-right pr-2">
                        {moneyFormatter(summary.totalBetAmount, summary.currencyCode)}
                    </td>
                    <td className="text-right pr-2">
                        {moneyFormatter(summary.totalWinAmount, summary.currencyCode, "text-danger")}
                    </td>
                    <td className="text-right pr-2">
                        {moneyFormatter(summary.totalBonusAmount, summary.currencyCode, "text-danger")}
                    </td>
                    <td className="text-right pr-2">
                        {moneyFormatter(summary.totalWinLoseAmount, summary.currencyCode, "text-primary")}</td>
                    <td className="text-right pr-2"/>
                </tr>
                </tbody>
            </table>
        </div>

        {
            totals > 0
                ? <div className="mt-2">
                    <Paginate
                        page={page}
                        size={size}
                        total={totals}
                        onChange={page => {
                            setPage(page);
                            onChangPage({page})
                        }}
                    />
                </div>
                : null
        }

        <SweetAlert
            title=""
            show={dataDetail != null}
            onConfirm={() => setDataDetail(null)}
            confirmBtnText={t("labels:common.close")}
            showCancel={false}
            btnSize="lg"
        >
            <TicketDetail dataDetail={dataDetail}/>
        </SweetAlert>
    </div>
}

export default memo(MainTableWinReport);